import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import {
  kKeyToLabelAndDefaultText,
  kPasswordMaskingKeys,
  kConnectorDataKeys
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { appcstr } from "@coreapp/utils/appcstr";

const BuildInputs = isMainImport => {
  const keys = isMainImport
    ? [...kConnectorDataKeys["PaySpace"], "pspljobs"]
    : kConnectorDataKeys["PaySpace"];

  return keys.map(key => ({
    dataKey: key,
    optional: ["pspljobs"].includes(key),
    label: appcstr(kKeyToLabelAndDefaultText[key][0]),
    placeholder: appcstr(kKeyToLabelAndDefaultText[key][1]),
    passwordMask: kPasswordMaskingKeys.includes(key.toLowerCase())
  }));
};

export const PaySpaceSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isAdditionalSource = importType !== "import";
  const atsType = isAdditionalSource ? enumATSModes.notATS : undefined;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isAdditionalSource}
      showLoadHeaders={isAdditionalSource}
      importType={importType}
      ATSType={atsType}
      doInputLookup={false}
      inputOptions={BuildInputs(!isAdditionalSource)}
    />
  );
};
